import { Dispatch, SetStateAction } from "react";

export const handleSubmitItem = async (
  method: () => Promise<any>,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
  setIsLoaded?: Dispatch<SetStateAction<boolean>>,
  type?: string,
  toastTitle?: string,
) => {
  try {
    setIsLoaded && setIsLoaded(false);
    const response = await method();

    if (response.status === 200 || response.status === 204) {
      addToast &&
        addToast({
          status: "success",
          title: "Sucesso",
          description: toastTitle ? toastTitle : "Alterações Guardadas",
        });
      return true;
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast &&
      addToast({
        status: "error",
        title: "Erro",
        description: `Ocorreu um erro ao ${
          type === "Create" ? "criar" : "alterar"
        } o item`,
      });
    setIsLoaded && setIsLoaded(true);
    return false;
  }
};
